"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnRendererContextLost = void 0;
/**
 * @public
 * Emitted when the renderer context is lost due to e.g. resource contention. Emitted on both chart and plots.
 */
class OnRendererContextLost {
    constructor(onRendererContextLost) {
        this.onRendererContextLost = onRendererContextLost;
    }
    static registerListener(chartEventService, onEvent) {
        return chartEventService
            .getCategory(OnRendererContextLost)
            .addTemporaryListener(new OnRendererContextLost(onEvent));
    }
    static emit(eventService) {
        const listeners = eventService
            .getCategory(OnRendererContextLost)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onRendererContextLost();
        }
    }
}
exports.OnRendererContextLost = OnRendererContextLost;
OnRendererContextLost.callbackKey = "onRendererContextLost";
//# sourceMappingURL=on-renderer-context-lost.js.map